type SipLogoutHandler = () => Promise<void> | void;

let currentSipLogoutHandler: SipLogoutHandler | undefined;

/**
 * Runs SIP logout workflow.
 */
export const logoutSip = async (): Promise<void> => {
	if (!currentSipLogoutHandler) return;
	await currentSipLogoutHandler();
};

/**
 * Function registerSipLogoutHandler.
 */
export const registerSipLogoutHandler = (handler: SipLogoutHandler) => {
	currentSipLogoutHandler = handler;

	return () => {
		if (currentSipLogoutHandler === handler) {
			currentSipLogoutHandler = undefined;
		}
	};
};
